module.exports = __webpack_public_path__ + "img/banner2.9a6f1cf3.jpg";